<template>
    <div class="menu">
        <div class="menu-overlay"><span></span></div>
        <div class="menu-navbar">
            <div class="navbar-logo">
                <router-link :to="{name: 'home'}"
                             title="Группа компаний Ренна">Группа компаний Ренна</router-link>
            </div>
            <div class="navbar-control">
                <div class="navbar-menu"
                     title="Меню"
                     @click="click"
                ><span></span></div>
            </div>
        </div>

        <nav>
            <ul class="nav">
                <li class="nav-item">
                    <router-link :to="{name: 'home'}">О компании</router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{name: 'ice-cream'}">Наша гордость</router-link>

                    <ul class="nav-child">

                        <li class="nav-child-item">
                            <router-link :to="{name: 'ice-cream'}">Мороженое</router-link>
                        </li>
                        <li class="nav-child-item">
                            <router-link :to="{name: 'homey'}"><nobr>По-домашнему</nobr> с&nbsp;Кубани</router-link>
                        </li>
                        <li class="nav-child-item">
                            <router-link :to="{name: 'cheesecakes'}">Сырки</router-link>
                        </li>
                        <li class="nav-child-item">
                            <router-link :to="{name: 'chezbi'}">Чизби</router-link>
                        </li>
                        <li class="nav-child-item">
                            <router-link :to="{name: 'chocolate'}">Шоколад</router-link>
                        </li>
                        <li class="nav-child-item">
                            <router-link :to="{name: 'molonez'}">Молонез</router-link>
                        </li>
                        <li class="nav-child-item">
                            <router-link :to="{name: 'risovashki'}">Рисовашки</router-link>
                        </li>
                        <li class="nav-child-item">
                            <router-link :to="{name: 'condensed-milk'}">Сгущенное молоко</router-link>
                        </li>
                    </ul>
                </li>

                <li class="nav-item">
                    <router-link :to="{name: 'history'}">Исторические вехи</router-link>
                </li>

                <li class="nav-item">
                    <router-link :to="{name: 'sites'}">Наши сайты</router-link>
                </li>

                <li class="nav-item">
                    <router-link :to="{name: 'zakupki'}">Поставщикам</router-link>
                </li>

                <li class="nav-item">
                    <router-link :to="{name: 'vacanciestd'}">Вакансии</router-link>

                    <ul class="nav-child">
                        <li class="nav-child-item">
                            <router-link :to="{name: 'vacanciestd'}">ТД&nbsp;Ренна</router-link>
                        </li>

                        <li class="nav-child-item">
                            <router-link :to="{name: 'vacanciesvgg'}">ООО&nbsp;ВГГ</router-link>
                        </li>

                        <li class="nav-child-item">
                            <router-link :to="{name: 'vacanciesrh'}">Управляющая компания</router-link>
                        </li>

                        <li class="nav-child-item">
                            <router-link :to="{name: 'vacancieslog'}">Ренна логистик</router-link>
                        </li>

                        <li class="nav-child-item">
                            <router-link :to="{name: 'vacanciesdist'}">Ренна дистрибуция</router-link>
                        </li>

                        <li class="nav-child-item">
                            <router-link :to="{name: 'vacanciesamkk'}">АМКК</router-link>
                        </li>

                        <li class="nav-child-item">
                            <router-link :to="{name: 'vacanciessov'}">ООО&nbsp;Советское</router-link>
                        </li>

                        <li class="nav-child-item">
                            <router-link :to="{name: 'vacancieskmkk'}">КМКК</router-link>
                        </li>

                        <li class="nav-child-item">
                            <router-link :to="{name: 'vacanciesfnm'}">ФНМ</router-link>
                        </li>

                    </ul>

                </li>

                <li class="nav-item">
                    <router-link :to="{name: 'contacts'}">Контакты</router-link>
                </li>
                
            </ul>
        </nav>
    </div>
</template>

<script>
    export default {
        name: "Menu",
        methods: {
            click() {
                this.$emit("click");
            }
        }
    }
</script>
